import React, { useEffect, useState, lazy } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { Section } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  const [spotsTaken, setSpotsTaken] = useState(71);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-185">
      <div className="bg-brand-purple text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-purpleLight/40" data-id="element-186">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-187">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-188">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-purple/40 bg-gradient-to-br from-white/95 to-brand-purpleLight/10 shadow-[0_10px_40px_rgba(45,95,63,0.12)]" data-id="element-189">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-190">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-purple shrink-0" data-id="element-191" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-purpleDark text-center" data-id="element-192">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-193">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-194" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-195">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-196" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-197">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-198" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-199">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-200" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-201">
            Después sube $25.000 ARS.{' '}
            <span className="text-brand-purple" data-id="element-202">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-purple/30" data-id="element-203">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-204">
            <div className="flex items-center gap-2" data-id="element-205">
              <span className="relative flex h-2.5 w-2.5" data-id="element-206">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-207"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-208"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-209">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-210">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-purple/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-211">
            <div className="bg-gradient-to-r from-brand-purple to-brand-purpleDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-212" />
          </div>
          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-213">
            <strong className="text-brand-purple" data-id="element-214">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomo1Features = ['✅ Psicología del orden clínico', '✅ Protocolo de sellado áurico profesional', '✅ Estructura de la sesión élite — KĀI / YÒNG / HÉ', '✅ Higiene energética del espacio entre pacientes', '✅ Ergonomía energética del terapeuta', '✅ Diagnóstico visual veloz del estado del paciente', '✅ El terapeuta como ser completo', '✅ Mapa del año terapéutico'];
const tomo2Features = ['✅ Biblioteca completa de series terapéuticas', '✅ Chi Kung clasificado por sistemas orgánicos', '✅ Protocolos por patología específica', '✅ Gestión de crisis energéticas en sesión', '✅ Tareas de práctica para el paciente en casa', '✅ Series adaptadas por nivel del paciente'];
const tomo3Features = ['✅ Planificación por estaciones energéticas', '✅ Agenda completa de 52 semanas', '✅ Plantillas de seguimiento clínico del paciente', '✅ Organización profesional del consultorio', '✅ Metas terapéuticas por trimestre', '✅ Registro de evolución por paciente'];
const tomos = [{
  n: 'I',
  cover: 'https://cdn.magicpatterns.com/uploads/jynD7f8T5XDD9UyyetqbjW/Captura_de_pantalla_2026-07-09_005238.png',
  title: 'Fundamentos Operativos y Blindaje del Terapeuta',
  subtitle: 'El sistema operativo completo del terapeuta profesional.',
  accent: 'text-brand-purpleDark',
  features: tomo1Features
}, {
  n: 'II',
  cover: 'https://cdn.magicpatterns.com/uploads/p8fdYg1hTd5WZcY6GboRPG/Captura_de_pantalla_2026-07-09_005317.png',
  title: 'Vademécum de Sesiones y Tratamientos',
  subtitle: 'La biblioteca clínica de Chi Kung más completa en español.',
  accent: 'text-brand-amber',
  features: tomo2Features
}, {
  n: 'III',
  cover: 'https://cdn.magicpatterns.com/uploads/qA8w8WpWd7T6Q58rhShCHT/Captura_de_pantalla_2026-07-09_005335.png',
  title: 'Planificador Anual 365',
  subtitle: 'Planificación estratégica de 52 semanas por estaciones.',
  accent: 'text-brand-greenMoss',
  features: tomo3Features
}];
type Bonus = {
  n: string;
  cover?: string;
  title: string;
  price: string;
};
const bonuses: Bonus[] = [{
  n: '01',
  cover: 'https://cdn.magicpatterns.com/uploads/izXiz8qHHHmhcF7NzwFYpE/Portada_bono_1.png',
  title: 'Cuaderno de Planificación Imprimible',
  price: '$12.000'
}, {
  n: '02',
  cover: 'https://cdn.magicpatterns.com/uploads/soQDKuVirwVNDfDTRKho9o/Portada_bono_2.png',
  title: '52 Guiones de Visualización',
  price: '$15.000'
}, {
  n: '03',
  cover: 'https://cdn.magicpatterns.com/uploads/mj6k5ncoTuy7xdPtbBKVa3/Portada_bono_3.png',
  title: 'Kit de Gráficos para el Consultorio',
  price: '$10.000'
}, {
  n: '04',
  cover: 'https://cdn.magicpatterns.com/uploads/fdQnLkSDXyfusoJCeSWn4K/Portada_bono_4.png',
  title: 'Protocolo de Chi Kung Adaptado',
  price: '$12.000'
}, {
  n: '05',
  cover: 'https://cdn.magicpatterns.com/uploads/eM4GmmLyaHVhBFXDtCHhqf/Portada_bono_5.png',
  title: 'Audio-Entrenamiento "Limpieza Rápida"',
  price: '$10.000'
}, {
  n: '06',
  cover: 'https://cdn.magicpatterns.com/uploads/igdVVLtCTu8WRsKKBwXCjE/Portada_bono_6.png',
  title: 'Curaduría de Sonidos Sanadores',
  price: '$10.000'
}];
export const PackContents = () => {
  return <Section id="method" className="relative" data-id="element-215">
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-25 animate-float-soft" color="#B45A34" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-216" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#7C8A4E" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-217" />
      <div className="text-center mb-8" data-id="element-218">
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-3 leading-tight text-brand-purpleDark" data-id="element-219">
          3 Tomos Principales + 6 Bonus Estratégicos
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-220">
          Más de 190 páginas — Todo resuelto.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-10" data-id="element-221">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-id="element-222">
          {tomos.map(tomo => <div key={tomo.n} className="glass-panel rounded-2xl overflow-hidden bg-white/90 border-brand-purple/20 flex flex-col p-4 md:p-5" data-id="element-223">
              <div className="flex items-start gap-3 mb-3" data-id="element-224">
                <div className="relative w-16 md:w-20 shrink-0 rounded-lg overflow-hidden shadow-md ring-1 ring-brand-purple/15" data-id="element-225">
                  <img src={tomo.cover} alt={`Tomo ${tomo.n} — ${tomo.title}`} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-226" />
                </div>
                <div className="min-w-0" data-id="element-227">
                  <span className={`inline-block ${tomo.accent} text-[10px] font-bold tracking-widest mb-1`} data-id="element-228">
                    TOMO {tomo.n}
                  </span>
                  <h4 className={`font-serif font-bold text-sm md:text-base leading-tight ${tomo.accent}`} data-id="element-229">
                    {tomo.title}
                  </h4>
                </div>
              </div>
              <ul className="space-y-1 text-xs text-brand-text" data-id="element-230">
                {tomo.features.map((f, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-231">
                    <span className={`${tomo.accent} shrink-0 font-bold`} data-id="element-232">
                      ✓
                    </span>
                    <span data-id="element-233">{f.replace('✅ ', '')}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      <div className="text-center mb-6 mt-10" data-id="element-234">
        <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-purpleDark" data-id="element-235">
          🎁 6 BONUS ESTRATÉGICOS —{' '}
          <span className="text-brand-goldDark" data-id="element-236">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-237">
        {bonuses.map(bonus => <div key={bonus.n} className="flex flex-col" data-id="element-238">
            <div className="relative rounded-xl overflow-hidden ring-1 ring-brand-purple/20 shadow-md bg-white aspect-[3/4]" data-id="element-239">
              {bonus.cover ? <img src={bonus.cover} alt={`Bono ${bonus.n} — ${bonus.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-240" /> : <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-3 bg-gradient-to-br from-brand-surfaceLight to-brand-greenSage/40" data-id="element-241">
                  <span className="text-[10px] font-bold tracking-widest text-brand-goldDark mb-2" data-id="element-242">
                    BONO {bonus.n}
                  </span>
                  <span className="text-3xl mb-2" aria-hidden="true" data-id="element-243">
                    🎵
                  </span>
                  <span className="font-serif font-bold text-brand-purpleDark text-[11px] md:text-xs leading-tight" data-id="element-244">
                    {bonus.title}
                  </span>
                </div>}
              <span className="absolute top-0 right-0 bg-brand-gold text-brand-purpleDark text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-245">
                GRATIS
              </span>
            </div>
            <p className="text-center text-[10px] md:text-[11px] text-brand-muted mt-1.5" data-id="element-246">
              <span className="line-through" data-id="element-247">{bonus.price}</span>
              <span className="ml-1 font-bold text-brand-goldDark" data-id="element-248">
                → GRATIS
              </span>
            </p>
          </div>)}
      </div>

      <div className="text-center mt-6" data-id="element-249">
        <div className="inline-block glass-panel px-5 py-2.5 rounded-full border-brand-purple/30 bg-white/80" data-id="element-250">
          <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-251">
            Valor total bonos{' '}
            <span className="line-through text-brand-text/50" data-id="element-252">$69.000</span>{' '}
            <span className="text-brand-purple font-bold" data-id="element-253">
              → GRATIS con tu Mega Pack
            </span>
          </p>
        </div>
      </div>
    </Section>;
};
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-254">
    <LaunchUrgency data-id="element-255" />
    <Pricing data-id="element-256" />
  </div>;